<button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" nz-button nzType="default">
  <span nz-icon nzType="table" nzTheme="outline"></span>
  <span>{{'Columns' | translate}}</span>
</button>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <div class="columns-container">
    <input nz-input type="text" placeholder="Search" [(ngModel)]="searchValue" [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="search();" />
    <nz-space [nzDirection]="'vertical'">
      <nz-row *nzSpaceItem class="columns-list">
        <ng-container *ngFor="let column of columnsList">
          <nz-col [hidden]="!(column.visibleInForSelection || column.visibleInForSelection == null)" nzXs="12" nzMd="8">
            <label nz-checkbox [(nzChecked)]="column.visible" (nzCheckedChange)="visibilityChanged();"
              [nzDisabled]="!column.visible && visibleColumns.length >= 25">
              {{ column.label }}
            </label>
          </nz-col>
        </ng-container>
      </nz-row>
      <nz-row *nzSpaceItem>
        <i>
          {{'You can select 25 columns, you select ' + visibleColumns.length + ' out of 25'}}
        </i>
      </nz-row>
    </nz-space>
  </div>
</nz-dropdown-menu>
